import { render, staticRenderFns } from "./ScheduleTable.vue?vue&type=template&id=1c84a18f&"
import script from "./ScheduleTable.vue?vue&type=script&lang=js&"
export * from "./ScheduleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QTable})
